import { createFileRoute } from "@tanstack/react-router";

import { InvoiceDetailPage } from "@/features/my/settings/account/invoices/invoice-detail";

export const Route = createFileRoute(
  "/(member)/(protected)/my/settings/account/invoices/$invoiceId",
)({
  component: InvoiceDetailPage,
});
